// GENERATED by scripts/build-icons.mjs from icons/clock.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Clock = createIcon('clock', [
  ['circle', { cx: "12", cy: "12", r: "10" }],
  ['path', { d: "M12 6v6l4 2" }],
])
